import { isOwnerOrAdmin } from '@/enums/merchant-type.enum'
import { isPsP } from '@/enums/business-model.enum'

const KYC_PERMISSIONS_ENUM = {
  view: 'kyc.status:view',
  create: 'kyc.qrcode:create'
}

const kycViewEnabled = permissionIsEnabledFn => {
  return permissionIsEnabledFn(KYC_PERMISSIONS_ENUM.view)
}

const kycQrCodeCreateEnabled = permissionIsEnabledFn => {
  return permissionIsEnabledFn(KYC_PERMISSIONS_ENUM.create)
}

const kycFeedbackBannerEnabled = (userType, businessModel, isTestAccount) => {
  return isOwnerOrAdmin(userType) && isPsP(businessModel) && isTestAccount
}

export {
  KYC_PERMISSIONS_ENUM,
  kycViewEnabled,
  kycQrCodeCreateEnabled,
  kycFeedbackBannerEnabled
}
